module.exports = __webpack_public_path__ + "font_hui_son.cfa2502f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_hui_son.png
// module id = MbZB
// module chunks = 0